export function directionsFilter() {
    // Handle filtering by transportation type
    const filterButtons = document.querySelectorAll(".farlo-time__filters .farlo-whats-on__filters-button");
    filterButtons.forEach(button => {
        button.addEventListener("click", function (e) {
            e.preventDefault();
            const type = this.textContent.trim().toLowerCase();
            const items = document.querySelectorAll(".transportations__item");

            if (this.classList.contains('active')) {
                // Remove filter if already active
                filterButtons.forEach(btn => btn.classList.remove('active'));
                items.forEach(item => item.style.display = "block");
                
                // Remove filter from URL
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.delete('filter');
                window.history.replaceState({}, '', `${window.location.pathname}`);
            } else {
                // Apply new filter
                filterButtons.forEach(btn => btn.classList.remove('active'));
                this.classList.add('active');
                items.forEach(item => {
                    item.style.display = item.getAttribute("data-transportation").toLowerCase() === type || type === "all" ? "block" : "none";
                });

                // Update URL without reloading
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set('filter', type);
                window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
            }
        });
    });

    // Retain filter selection on reload
    const urlParams = new URLSearchParams(window.location.search);
    const selectedFilter = urlParams.get('filter');
    if (selectedFilter) {
        filterButtons.forEach(button => {
            if (button.textContent.trim().toLowerCase() === selectedFilter) {
                button.classList.add('active');
            }
        });
        document.querySelectorAll(".transportations__item").forEach(item => {
            item.style.display = item.getAttribute("data-transportation").toLowerCase() === selectedFilter || selectedFilter === "all" ? "block" : "none";
        });
    }
}
